/* eslint-disable @next/next/no-img-element */
//components
import { PillLink } from '@/containers-ai/Buttons';

//styles
import {
  HeroSection,
  HeroBg,
  HeroVisual,
  HeroOverlay,
  HeroInner,
  HeroKicker,
  HeroTitle,
  HeroDescription,
  HeroCta,
} from './Hero.styles';

export function Hero() {
  return (
    <HeroSection id="top">
      <HeroBg aria-hidden="true">
        <HeroVisual
          src="/images/contact/hero-lg.webp"
          srcSet="/images/contact/hero-sm.webp 700w, /images/contact/hero-md.webp 1400w, /images/contact/hero-lg.webp 2400w"
          sizes="100vw"
          fetchpriority="high"
          alt=""
        />
        <HeroOverlay />
      </HeroBg>
      <HeroInner>
        <HeroKicker>We&rsquo;d love to hear from you</HeroKicker>
        <HeroTitle>Contact us</HeroTitle>
        <HeroDescription>
          Let&rsquo;s talk! We&rsquo;d love to hear about your logistics
          challenges and discuss how our tailored logistics solutions and
          technology can help you lower costs, increase efficiency, and
          digitize transportation.
        </HeroDescription>
        <HeroCta>
          <PillLink href="#contact-form" className="qlf-btn-1">
            Get in Touch →
          </PillLink>
        </HeroCta>
      </HeroInner>
    </HeroSection>
  );
}
